import { httpAviationReportingAuthentication } from '../../http-common';
import { httpAviationApim } from '../../utils/aviationAPIMConfig';
import { IFlightReport } from '../../model/IFlightReport';
import { AxiosResponse } from 'axios';
import { IValidationResult } from '../../model/errors/IValidationResult';
import { IResult } from '../../model/search/IResult';

const getAuthenticate = async () => {
  const data = await httpAviationReportingAuthentication.post<string>('/authentication/authenticate', {
    username: 'andrew.mitchell',
    password: 'password',
  });

  return data;
};

const getById = async (id: any, strToken: string = ''): Promise<IResult<IFlightReport>> => {
  const data = await httpAviationApim.post<IResult<IFlightReport>>(`/flight-report/get/${id}`, '', {
    headers: {
      Authorization: `Bearer ${strToken}`,
    },
  });

  return data.data;
};

const update = async (
  flightReport: IFlightReport,
  strToken: string = '',
  ignoreWarning: boolean = true,
): Promise<IValidationResult<IFlightReport>> => {
  const params = JSON.stringify(flightReport);

  const data = await httpAviationApim.put<IValidationResult<IFlightReport>>(
    `/flight-report/update/${flightReport.flightReportId}?ignoreWarning=${ignoreWarning}`,
    params,
    {
      headers: {
        Authorization: `Bearer ${strToken}`,
      },
    },
  );

  return data.data;
};

const updateFlagged = async (flightReport: IFlightReport, strToken: string = '') => {
  const params = JSON.stringify({
    flightReportId: flightReport.flightReportId,
    isFlagged: flightReport.isFlagged,
  });

  // const data = await httpAviationReporting.put<IFlightReport>(
  //   `/flight-report/update/flag/${flightReport.flightReportId}`,
  //   params,
  //   {
  //     headers: {
  //       Authorization: `Bearer ${sessionStorage.getItem("api_token")}`,
  //     },
  //   }
  // );

  const data = await httpAviationApim.put<IFlightReport>(`/flight-report/update/flag/${flightReport.flightReportId}`, params, {
    headers: {
      Authorization: `Bearer ${strToken}`,
    },
  });

  return data;
};

const create = async (
  flightReport: IFlightReport,
  strToken: string = '',
  ignoreWarning: boolean = true,
): Promise<IValidationResult<IFlightReport>> => {
  const params = JSON.stringify(flightReport);

  const data = await httpAviationApim.post<IValidationResult<IFlightReport>>(`/flight-report/create?ignoreWarning=${ignoreWarning}`, params, {
    headers: {
      Authorization: `Bearer ${strToken}`,
    },
  });

  return data.data;
};

const deleteById = async (flightReport: IFlightReport, strToken: string = '') => {
  const params = JSON.stringify(flightReport);

  const data = await httpAviationApim.put<IFlightReport>(`/flight-report/delete/${flightReport.flightReportId}`, params, {
    headers: {
      Authorization: `Bearer ${strToken}`,
    },
  });

  return data;
};

const getPdf = async (flightReportId: number, strToken = ''): Promise<AxiosResponse<Blob, any>> => {
  const data = await httpAviationApim.get<Blob>(`/flight-report/getPdf/${flightReportId}`, {
    headers: {
      Authorization: `Bearer ${strToken}`,
      CacheControl: 'no-cache',
      Pragma: 'no-cache',
      Expires: '0',
    },
    responseType: 'blob',
    params: { timestamp: new Date().getTime() },
  });

  return data;
};

export const FlightReportService = {
  getAuthenticate,
  getById,
  update,
  updateFlagged,
  create,
  deleteById,
  getPdf,
};
